module.exports = __webpack_public_path__ + "img/logo.f21a6ca3.jpg";